
/**
 * Reads a path inside of an object
 * @param {String} path 
 * @param {Object} obj 
 */
export function read(path, obj) {
  let current = obj;
  path.split('.').forEach((p) => { current = current[p]; });
  return current;
}

/**
 * Mutates the given object on the given path
 * @param {String} path 
 * @param {Object} obj 
 * @param {Any} value 
 */
export function write(path, obj, value) {
  const result = { ...obj };
  let current = result;
  const inner = path.split('.');

  inner.forEach((p, index) => {
    
    if (index < (inner.length - 1)) {
      current = current[p];
    } else {
      current[p] = value;
    }
  });

  return result;
}